import { useTranslations } from 'next-intl';

export const ThingsKnow = ({ houseRules, cancellationPolicy }) => {
  const t = useTranslations();
  return (
    <>
      {(houseRules || cancellationPolicy) && (
        <div className="flex flex-wrap gap-[46px] border-t border-slate-300 pt-8 pb-10 lg:pr-8">
          {houseRules && (
            <div className="flex flex-col gap-4 min-w-[250px] flex-1">
              <div className="text-primary-800 text-base font-medium">
                {t('apartment.rules.title')}
              </div>
              <div className="flex flex-col gap-3">
                <div
                  className="text-slate-500 text-sm"
                  dangerouslySetInnerHTML={{
                    __html: houseRules.replaceAll('\n', '<br />'),
                  }}
                />
              </div>
            </div>
          )}
          {cancellationPolicy && (
            <div className="flex flex-col gap-4 min-w-[250px] flex-1">
              <div className="text-primary-800 text-base font-medium">
                {t('apartment.policy.title')}
              </div>
              <div className="flex flex-col gap-3">
                <div
                  className="text-slate-500 text-sm"
                  dangerouslySetInnerHTML={{
                    __html: cancellationPolicy.replaceAll('\n', '<br />'),
                  }}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
